// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"43fdcf25","554":"43fdcf25"}[chunkId] + ".chunk.css";
};